import {useDispatch,useSelector} from 'react-redux'
import {useEffect,useState} from 'react'
import {envAwarePost} from '../../util/util'
import useCurrentUser from '../../hooks/useCurrentUser'
import useBranding from '../../hooks/useBranding'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import Button from 'react-bootstrap/Button'
import {Link} from 'react-router-dom'

import {getNewActivityCount,clear} from './slice'

const NotificationBell = ()=>{
	const dispatch = useDispatch()
	const newActivityCount = useSelector(state=>state.activityCount.count)
	const customBranding = useBranding()
	const {isMAXUser} = useCurrentUser()
	useEffect(()=>{
		dispatch(getNewActivityCount())
	},[])
	return (
		<OverlayTrigger
			placement="bottom"
			delay={{ show: 400 }}
			overlay={
				<Tooltip>
					Notifications
				</Tooltip>
			}
		>

			<Button 
				to='/notification_dashboard' 
				variant="link"
				as={Link}
				style={{
					color:customBranding ? customBranding.textColor : "#fff",
				}}
				onClick={()=>{dispatch(clear())}}
			>
				<i 
					style={{
						color:customBranding ? customBranding.textColor : "#fff",
					}}
					className="fa fa-bell"
				/>
				{newActivityCount>0&&
					<small className="ml-1">
						{newActivityCount}
					</small>
				}
			</Button>
		</OverlayTrigger>
	)
}

export default NotificationBell